export class EnvironmentService {
  static getBaseUrl(): string {
    if (window.location.port === "8080") {
      const port = window.location.protocol === "http:" ? "9101" : "9100";
      return window.location.protocol + "//" + window.location.hostname + ":" + port;
    }

    return window.location.pathname.replace(/\/+$/, "");
  }

  static isDevelopment(): boolean {
    return !!this.getBaseUrl();
  }
}
